export default "__VITE_ASSET__Bb0phCn5__"